<img *ngIf="!sharedService.mobile" src="../../../assets/images/translucentOhaLogo.png" class="bg" alt="OHA Logo">

<img *ngIf="sharedService.mobile" src="../../../assets/images/translucentOhaLogo.png" class="bg-mobile" alt="OHA Logo">

<div class="home-shell">
  <div class="title-wrap">
    <span class="home-title" *ngIf="!sharedService.isMobile">{{ title }}</span>
    <span class="home-title mobile" *ngIf="sharedService.isMobile">{{ titleMobile }}</span>
  </div>

  <div class="welcome-surface">
    <section class="welcome-column continue-column">
      <h2>Already have an account?</h2>
      <p>Continue where you left off</p>
      <button mat-stroked-button color="primary" type="button" (click)="continue()">
        Continue
      </button>
    </section>

    <section class="welcome-column">
      <h2>New user?</h2>
      <p>Select an option to get started</p>

      <div class="options-grid">
        <button mat-button type="button" class="option-launch" *ngFor="let option of homeOptions" (click)="openInfoPanel(option)">
          <span class="option-card" [ngStyle]="{ 'background': getOptionColor(option), 'box-shadow': getOptionShadow(option) }">
            <mat-icon class="option-icon">{{ option.icon }}</mat-icon>
            <span class="option-label">{{ option.title }}</span>
          </span>
        </button>
      </div>
    </section>
  </div>
</div>

<div class="overlay-backdrop" *ngIf="selectedOption">
  <section class="overlay-panel info-panel" [ngStyle]="selectedOption ? { 'border-top': '6px solid ' + getOptionColor(selectedOption) } : null">
    <h3>{{ selectedOption.title }}</h3>
    <p [innerHTML]="selectedOption.description"></p>

    <div class="overlay-actions">
      <button mat-stroked-button type="button" (click)="closeInfoPanel()">Close</button>
      <button mat-raised-button type="button" color="primary" (click)="startSelectedFlow()">Get Started</button>
    </div>
  </section>
</div>

<div class="overlay-backdrop" *ngIf="showAttestationModal">
  <section class="overlay-panel attestation-panel">
    <h3>System Use Attestation</h3>

    <p>The Lead-based Paint Data System is operated by the Oregon Health Authority (OHA) in support of environmental and public health functions. This system contains sensitive and confidential information protected under applicable federal and state law and agency policy.</p>

    <p>This is an official State of Oregon information system and is provided for authorized use only.</p>

    <p>Access is restricted to authorized users for lawful and official State of Oregon business purposes. By selecting <strong>Continue</strong>, you acknowledge and agree to the following:</p>

    <ul>
      <li>You will access and use information within this system only as necessary to perform authorized environmental, regulatory, or public health functions consistent with Oregon law and agency policy.</li>
      <li>You will not access, use, disclose, copy, distribute, or otherwise misuse information for any unauthorized, personal, or commercial purpose.</li>
      <li>You will not attempt to circumvent security and privacy controls, perform unauthorized data extraction, alter system functionality, or interfere with system integrity.</li>
      <li>All access and activity within this system may be monitored, recorded, logged and audited to ensure compliance with privacy, security, and regulatory requirements.</li>
      <li>Unauthorized access, use, disclosure, alteration, or destruction of information may result in revocation of access, administrative discipline, civil penalties, and up to criminal prosecution under applicable law.</li>
      <li>Users are responsible for reporting suspected unauthorized access or misuse in accordance with agency policy.</li>
    </ul>

    <mat-checkbox [(ngModel)]="agreedToTerms" class="attestation-checkbox">
      <strong>I agree to the terms and conditions above.</strong>
    </mat-checkbox>

    <div class="overlay-actions">
      <button mat-stroked-button type="button" (click)="closeAttestationModal()">Close</button>
      <button mat-raised-button type="button" color="primary" [disabled]="!agreedToTerms" (click)="confirmAttestation()">Continue</button>
    </div>
  </section>
</div>

<div *ngIf="sharedService.loading">
  <div id="globalLoader" class="global-loader" [ngStyle]="{ 'background-color': sharedService.darkMode ? '#333' : '#fff' }">
    <h1>Loading</h1>
  </div>
</div>

